import Config from "../../common/config/config";

export default class ScrollEvent {
    constructor() {
        this.main = document.querySelector(".js-main-inner");
        this._init();
    }

    _init() {
        this.wh = window.innerHeight;
        this.scrolled_y = window.pageYOffset;
    }

    start(branchList) {
        this.branchList = branchList;

        // 要素が全て揃ったタイミングで処理開始
        this._observeDOM(() => {
            this.$books = this.main.querySelectorAll(".branches__item");

            [...this.$books].forEach(($book) => {
                if ($book.classList.contains("-active")) {
                    $book.classList.remove("-active");
                }
            });

            if (this.$books.length > 0) {
                this._waitForRender(() => {
                    window.addEventListener("resize", this._checkScrollPos.bind(this));
                    window.addEventListener("scroll", this._checkScrollPos.bind(this));
                    this._checkScrollPos();
                    this._branchUpdate();
                });
            }
        });
    }

    _waitForRender(callback) {
        const isRendered = () => {
            const allRendered = [...this.$books].every(($book) => {
                const childElements = $book.querySelectorAll("*");
                return Array.from(childElements).every((child) => child.offsetHeight > 0 || child.offsetWidth > 0);
            });

            if (allRendered) {
                callback(); // 全ての内部要素が描画されていたらコールバック発火
            } else {
                requestAnimationFrame(isRendered); // 再チェック
            }
        };

        isRendered();
    }

    _observeDOM(callback) {
        const targetNode = document.body;
        const config = { childList: true, subtree: true };

        const observer = new MutationObserver(() => {
            if (document.querySelectorAll(".branches__item").length > 0) {
                observer.disconnect();
                callback();
            }
        });

        observer.observe(targetNode, config);
    }

    _checkScrollPos() {
        this.wh = window.innerHeight;
        this.scrolled_y = window.pageYOffset;
        this._bookItemUpdate();
        this._fixContent();
    }

    _branchUpdate() {
        for (let i = 0; i < this.branchList.length; i++) {
            this.branchList[i].update();
        }
    }

    _bookItemUpdate() {
        [...this.$books].forEach(($book) => {
            const oy = $book.getBoundingClientRect().top + this.scrolled_y;
            const sy = this.scrolled_y + this.wh * 0.9;

            if (sy >= oy) {
                if (!$book.classList.contains("-active")) {
                    const delay = Math.random() * 700;

                    setTimeout(() => {
                        $book.classList.add("-active");
                    }, delay);
                }
            }
        });
    }

    _fixContent() {
        try {
            const topbtn = document.querySelector(".c-visible_wide .c-topbtn__box");
            const questionary = document.querySelector(".nm__footer");

            if (topbtn && questionary) {
                const questionaryTop = questionary.offsetTop;

                if (this.scrolled_y + this.wh >= questionaryTop - 10) {
                    topbtn.classList.remove("-fixed");
                } else {
                    topbtn.classList.add("-fixed");
                }
            }
        } catch (e) {}
    }
}
